import { http } from '@/_services/http.service'

export const reactionService = {

    getReactions(limit){
        const options = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        }

        return http.fetch(`${process.env.VUE_APP_API_URL}/houses/archive&limit=${limit}`, options)
            .then(response => response.json())
    },
    deleteReaction(advert){
        const options = {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ advert })

        }
        return http.fetch(`${process.env.VUE_APP_API_URL}/houses/archive`, options)
            .then(response => response.json())
    },
    withdrawReaction(advert){
        const options = {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ advert })

        }
        return http.fetch(`${process.env.VUE_APP_API_URL}/houses/archive`, options)
            .then(response => response.json())
    },
    getLetters(){
        const options = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        }

        return http.fetch(`${process.env.VUE_APP_API_URL}/user/letters&house=false`, options)
            .then(response => response.json())
    },


}